import React from 'react';
import Router from './ui/pages/Router';
import './index.css';
import { createRoot } from 'react-dom/client';
import { createTheme, ThemeProvider } from '@mui/material';

const container = document.getElementById('root');
const root = createRoot(container!);

const theme = createTheme({
  breakpoints: {
    values: {
      xs: 0,
      sm: 1280,
      md: 1360,
      lg: 1920,
      xl: 2560,
    },
  },
});

root.render(
  <React.StrictMode>
    <ThemeProvider theme={theme}>
      <Router />
    </ThemeProvider>
  </React.StrictMode>,
);
